import { InfoOutlined } from '@mui/icons-material';
import { Tooltip, type TooltipProps } from '@mui/material';
import type { FC } from 'react';

type Props = Omit<TooltipProps, 'title' | 'children'> & {
  tip: string;
};

export const InputTooltip: FC<Props> = ({ tip, ...props }) => (
  <Tooltip title={tip} {...props}>
    <InfoOutlined sx={{ fontSize: 16 }} />
  </Tooltip>
);
